const kontakt = {
	'contact.title': 'Contact',
	'contact.form.subject': 'Subject',
	'contact.form.email': 'Email',
	'contact.form.message': 'Message',
	'contact.form.submit': 'Send',
	'contact.form.emailSentMessage': 'Mail sent!',
	'contact.form.emailFailedMessage': 'Failed sending mail, please try again',
	'contact.location': 'Location',
	'contact.address.title': 'Address',
	'contact.address': 'Rannaküla , Lääneranna vald, 88228 Pärnu maakond',
	'contact.mobile.title': 'Mobile phone',
	'contact.mobile': '(+372) 506 1879',
	'contact.phone.title': 'Phone',
	'contact.phone': '(+372) 449 6682',
	'contact.email.title': 'E-mail',
	'contact.email': 'varblapk@gmail.com',
	'contact.socialmedia': 'Social media',
	'contact.distances':
		'Distances from big cities: Pärnu 75 km, Tallinn 150km, Tartu 250 km',
};

export default kontakt;
